module.exports = __webpack_public_path__ + "static/img/ngzg_new.dfe7ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngzg_new.png
// module id = Ez8k
// module chunks = 3